import React from "react";

import DetalleCard from "~business/Cards/DetalleCard";

import DescriptionIcon from "@mui/icons-material/Description";
import { useSelector } from "react-redux";
import ItemFileUploaderCard from "~business/Cards/ItemFileUploaderCard";

const title = "Documentación";

interface ImpresosCardProps {
  isLoading: boolean;
}

interface SliceImpresos {
  ubicacionCedulaMercosur?: string;
  ubicacionCuponera?: string;
  ubicacionPoliza?: string;
  ubicacionTarjeta?: string;
  negocio?: string;
}

const useReduxSelector = () =>
  useSelector<any, SliceImpresos>((state) => {
    const certificados = state.detallePolizaNuevoReducer.currentPoliza
      ? state.detallePolizaNuevoReducer.currentPoliza.certificados
      : {};

    return {
      ...state.detallePolizaNuevoReducer,

      ubicacionCedulaMercosur: certificados.ubicacionCedulaMercosur,
      ubicacionCuponera: certificados.ubicacionCuponera,
      ubicacionPoliza: certificados.ubicacionPoliza,
      ubicacionTarjeta: certificados.ubicacionTarjeta,
      negocio: state.detallePolizaNuevoReducer.currentPoliza
        ? state.detallePolizaNuevoReducer.currentPoliza.negocio
        : undefined,
    };
  });

const ImpresosCard: React.FC<ImpresosCardProps> = ({ isLoading }) => {
  const state = useReduxSelector();
  const {
    ubicacionCedulaMercosur,
    ubicacionCuponera,
    ubicacionTarjeta,
    ubicacionPoliza,
    negocio,
  } = state;

  return (
    <DetalleCard
      isLoading={isLoading}
      title={title}
      IconHeader={DescriptionIcon}
    >
      <ItemFileUploaderCard
        isLoading={isLoading}
        label={"Póliza"}
        value={ubicacionPoliza}
        readOnly
      />
      <ItemFileUploaderCard
        isLoading={isLoading}
        label={"Tarjeta"}
        value={ubicacionTarjeta}
        readOnly
      />
      <ItemFileUploaderCard
        isLoading={isLoading}
        label={"Cédula Mercosur"}
        value={ubicacionCedulaMercosur}
        readOnly
      />
      {negocio && negocio === "MercadoAbierto" && (
        <ItemFileUploaderCard
          isLoading={isLoading}
          label={"Cuponera"}
          value={ubicacionCuponera}
          readOnly
        />
      )}
    </DetalleCard>
  );
};

export default ImpresosCard;
